import type { IconData } from '@stacksjs/iconify-core'

export const businessProductsDataFileBars: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M27.43 6.09h-4.57V1.52h1.52V0H3.05v32h25.9V4.57h-1.52Zm0 24.39H4.57V1.52h16.76v6.1h6.1Z\"/><path fill=\"currentColor\" d=\"M25.91 3.05h1.52v1.52h-1.52Zm-1.53-1.53h1.53v1.53h-1.53Zm-3.05 21.34h-1.52v-9.15h-3.05v9.15h-1.52v-6.1h-3.05v6.1H7.62v-3.05h1.52v-1.52H7.62v-3.05h1.52v-1.53H7.62v-3.04H6.1v13.71h19.81v-1.52h-1.53v-7.62h-3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default businessProductsDataFileBars
